
    <mat-card-content>
      <div *ngIf="data">
        <div class="brand-header"  *ngIf="data.type === 'brand'">
          <ng-container *ngIf="data?.logo">
            <img [src]="data.logo" class="brand-logo" alt="{{data.companyName}}">
          </ng-container>
          <div class="brand-details">
            <h1>{{ data.companyName | camelcase}}</h1>
            <ng-container *ngIf="data?.url">
              <a class="data-url" (click)="sanitizeUrl(data.url); $event.preventDefault();"
              rel="noopener noreferrer"
               >{{ data.url }}</a>
            </ng-container>
          </div>
        </div>

        <div class="brand-header" *ngIf="data.type === 'distributor'">
          <ng-container *ngIf="data?.logo">
            <img [src]="data.logo" class="brand-logo" alt="{{data.companyName}}">
          </ng-container>
          <div class="brand-details">
            <h1>{{ data.companyName | camelcase}}</h1>
            <ng-container *ngIf="data?.url">
              <a class="data-url" target="_blank" href="{{ data.url }}">{{ data.url }}</a>
            </ng-container>
          </div>
        </div>
      </div>

     <ng-container *ngIf="data">
      <div [innerHTML]="this.data?.description" class="description"></div>
     <div class="video-photo">
      <ng-container *ngIf="data.videos && data.videos.length > 0">
        <div class="video-section d-none d-md-block d-lg-block">
          <div *ngFor="let video of data.videos">
              <!-- <video width="100%" class="video-part" controls >
                  <source [src]="video" type="video/mp4" >
                  Your browser does not support the video tag.
              </video> -->
              <iframe class="video-part" [src]="getEmbedUrl(video) | safe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

          </div>
      </div>
      <div class="video-section1  d-md-none d-lg-none">
        <div *ngFor="let video of data.videos">
            <iframe class="video-part" [src]="getEmbedUrl(video) | safe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </div>
    </ng-container>
      <ng-container *ngIf="data.photos && data.photos.length > 0">
          <div class="image-section d-none d-md-block d-lg-block">
              <img *ngFor="let photo of data.photos" [src]="photo" alt="Image" class="pics">
          </div>
          <div class="image-section1 d-md-none d-lg-none">
            <img *ngFor="let photo of data.photos" [src]="photo" alt="Image" class="pics">
        </div>
      </ng-container>
  </div>
</ng-container>
      <!-- <div class="grid-container">
        <div class="grid-item item1">
          <iframe [src]="videoUrl" title="YouTube video player" frameborder="0" allowfullscreen></iframe>
        </div>
        <div class="grid-item" *ngFor="let image of visibleImages; let i = index">
          <img [src]="image" alt="Image">
        </div>
        <div class="grid-item show-more" *ngIf="!showMore && images.length > 6" (click)="toggleShowMore()">
          <div class="more-image-container">
            <img [src]="images[5]" alt="Image" class="more-image">
            <div class="overlay">+{{ hiddenImagesCount }}</div>
          </div>
        </div>
        <ng-container *ngIf="showMore">
          <div class="grid-item" *ngFor="let image of images.slice(6)">
            <img [src]="image" alt="Image">
          </div>
        </ng-container>
      </div> -->
      

      
    </mat-card-content>

  
